// msal-plugin.js
import Vue from "vue";
import * as msal from "@azure/msal-browser";
import { msalConfig } from '@/config/authConfig';

// Create a Singleton Instance of MSAL
export const msalInstance = new msal.PublicClientApplication(msalConfig);

export const useMSAL = () => {
  const instance = new Vue({
    data() {
      return {
        isAuthenticated: false,
        account: null,
        error: null,
      };
    },
    async created() {
      try {
        // Handle redirect flows on page load
        await msalInstance.handleRedirectPromise();
        this.checkAuth();
      } catch (error) {
        this.error = error;
      }
    },
    methods: {
      checkAuth() {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          this.account = accounts[0];
          this.isAuthenticated = true;
          // Set active account for silent token requests
          msalInstance.setActiveAccount(this.account); 
        } else {
          this.isAuthenticated = false;
        }
      },
      async signInPopup(request) {
        try {
          const response = await msalInstance.loginPopup(request);
          this.checkAuth();
          return response;
        } catch (error) {
          console.error(error);
        }
      },
      signInRedirect(request) {
        msalInstance.loginRedirect(request);
      },
      async signOut() {
        await msalInstance.logoutRedirect({ account: this.account });
      }
    }
  });
  return instance;
};

export const MSALPlugin = {
  install(Vue) {
    Vue.prototype.$msal = useMSAL();
  },
};